import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MGTRequestComponent } from './mgtrequest/mgtrequest.component';


@Component({
  selector: 'app-mgt',
  templateUrl: './mgt.component.html',
  styleUrls: ['./mgt.component.css']
})
export class MGTComponent implements OnInit{

  ModalData:any=''

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _mdr: MatDialogRef<MGTComponent>,
    public dialog: MatDialog,

  ){
    this.ModalData = data.DocName;
  }

  ngOnInit(): void {
      
  }

  Close(){
    this._mdr.close(false)
  }

  OpenRequestMGT(){
    const MGT = this.dialog.open(MGTRequestComponent,{width:'30%',height:'70%', data:{DocName:this.ModalData}});

  }
}
